import { render, staticRenderFns } from "./VehicleDetailUsages.vue?vue&type=template&id=044bac86"
import script from "./VehicleDetailUsages.vue?vue&type=script&lang=js"
export * from "./VehicleDetailUsages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports